(function(){
  'use strict';

  /* Clean SVG line icons (Lucide/Feather style) */
  var svgs = [
    /* Clock - Tidsåtgång */
    '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#1d1d1f" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>',
    /* Tool/Wrench - Svårighet */
    '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#1d1d1f" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></svg>',
    /* Layers/Stack - Spill */
    '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#1d1d1f" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 2 7 12 12 22 7 12 2"/><polyline points="2 17 12 22 22 17"/><polyline points="2 12 12 17 22 12"/></svg>',
    /* Thermometer - Golvvärme */
    '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#1d1d1f" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M14 14.76V3.5a2.5 2.5 0 0 0-5 0v11.26a4.5 4.5 0 1 0 5 0z"/></svg>'
  ];

  var pills = document.querySelectorAll('.nw-diy .nw-grid4 .nw-pill');
  pills.forEach(function(p, i){
    if(svgs[i] && !p.querySelector('svg')){
      var wrap = document.createElement('span');
      wrap.style.cssText = 'display:flex;justify-content:center;margin-bottom:10px;opacity:.85;';
      wrap.innerHTML = svgs[i];
      var strong = p.querySelector('strong');
      if(strong) strong.parentNode.insertBefore(wrap, strong);
    }
  });

  /* Step icons */
  var stepSvgs = [
    /* 1. Search/Inspect - Kontrollera undergolv */
    '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>',
    /* 2. Ruler/Align - Startlinje & rytm */
    '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 3H3v18h18V3zM9 3v18M15 3v18M3 9h18M3 15h18"/></svg>',
    /* 3. Scissors - Kapning & finish */
    '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="6" cy="6" r="3"/><circle cx="6" cy="18" r="3"/><line x1="20" y1="4" x2="8.12" y2="15.88"/><line x1="14.47" y1="14.48" x2="20" y2="20"/><line x1="8.12" y1="8.12" x2="12" y2="12"/></svg>'
  ];

  var steps = document.querySelectorAll('.nw-diy details.nw-step');
  steps.forEach(function(step, i){
    if(stepSvgs[i]){
      var badge = step.querySelector('.nw-step-badge');
      if(badge && !badge.querySelector('svg')){
        badge.innerHTML = '';
        badge.innerHTML = '<span style="display:flex;align-items:center;justify-content:center;width:100%;height:100%;color:#fff;">' + stepSvgs[i] + '</span>';
      }
    }
  });

  /* Hover interactions */
  var style = document.createElement('style');
  style.textContent = [
    '.nw-diy .nw-pill{position:relative;transition:all .35s cubic-bezier(.25,.1,.25,1);cursor:default}',
    '.nw-diy .nw-pill:hover{transform:translateY(-4px);box-shadow:0 8px 24px rgba(0,0,0,.12);border-color:#1d1d1f!important}',
    '.nw-diy .nw-pill:hover svg{stroke:#1d1d1f;opacity:1;transition:stroke .3s}',
    '.nw-diy details.nw-step{transition:all .35s cubic-bezier(.25,.1,.25,1)!important}',
    '.nw-diy details.nw-step:hover{transform:translateY(-2px);box-shadow:0 6px 20px rgba(0,0,0,.06)}',
    '.nw-diy .nw-choice{transition:all .35s cubic-bezier(.25,.1,.25,1)!important;position:relative}',
    '.nw-diy .nw-choice:hover{transform:translateY(-3px);box-shadow:0 6px 20px rgba(0,0,0,.1);border-color:#1d1d1f!important}',
    '.nw-diy .nw-btn:active{transform:scale(.97)!important}',
    '.nw-diy .nw-step-badge{transition:all .35s cubic-bezier(.25,.1,.25,1)}',
    '.nw-diy details.nw-step[open] .nw-step-badge{transform:scale(1.1);box-shadow:0 4px 12px rgba(0,0,0,.25)}',
    '.nw-diy .nw-rec.is-active{animation:nwFadeUp .5s cubic-bezier(.25,.1,.25,1)}',
    '@keyframes nwFadeUp{from{opacity:0;transform:translateY(16px)}to{opacity:1;transform:translateY(0)}}'
  ].join('\n');
  document.head.appendChild(style);
})();
